import { ChevronDoubleLeftIcon, } from "@heroicons/react/24/outline"; // Heroicons v2
import createIcon from "./createIcon";

const FirstPage = createIcon(ChevronDoubleLeftIcon, "FirstPage");

export default FirstPage;
